import { Schema } from 'normalizr';
import { transformUtil } from '@eb/transformation-utils';
import {
    PaginatedResponse,
    PaginatedResponseFormatted,
} from './pagination.types';

const userInstrumentsSchema = new Schema('user_instruments');

export interface UserInstrumentsResponse extends PaginatedResponse {
    user_instruments: Array<{
        instrument_type: string;
        vault_id: string;
        user_id: string;
        owner_id: string;
        owner_type: string;
        instrument: {
            instrument_type: string;
            card_type: string;
            full_card_mask: string;
            expiration_date: string;
            is_debit: any | null; // TODO: Find proper type for this
        };
        billing_information: {
            first_name: string;
            last_name: string;
            email: string;
            address: {
                address_1: string;
                postal_code: string;
                city: string;
                region: string;
                country: string;
            };
        };
        expires_at: string;
        verified: string;
        created: string;
        changed: string;
        resource_uri: string;
    }>;
}

export interface UserInstrumentsResponseFormatted
    extends PaginatedResponseFormatted {
    userInstruments: Array<{
        instrumentType: string;
        vaultId: string;
        userId: string;
        ownerId: string;
        ownerType: string;
        instrument: {
            instrumentType: string;
            cardType: string;
            fullCardMask: string;
            expirationDate: string;
            isDebit: any | null; // todo: Find proper type for this
        };
        billingInformation: {
            firstName: string;
            lastName: string;
            email: string;
            address: {
                address_1: string;
                postalCode: string;
                city: string;
                region: string;
                country: string;
            };
        };
        expiresAt: string;
        verified: string;
        created: string;
        changed: string;
        resourceUri: string;
    }>;
}

export const transformUserInstruments = (data: UserInstrumentsResponse) => {
    const transformedUserInstruments = transformUtil({
        response: data,
        schema: userInstrumentsSchema,
    });

    if (!transformedUserInstruments) {
        return null;
    }

    return transformedUserInstruments.entities.user_instruments[
        transformedUserInstruments.result
    ] as UserInstrumentsResponseFormatted;
};
